import { render, staticRenderFns } from "./Boards4User.vue?vue&type=template&id=0bee3cab&scoped=true&"
import script from "./Boards4User.vue?vue&type=script&lang=js&"
export * from "./Boards4User.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bee3cab",
  null
  
)

export default component.exports